import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaTimes } from "react-icons/fa";
import CommonTable from "../../components/CommonTable/CommonTable";
import { BASE_URL, URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import "./PinCode.css";
import moment from "moment/moment";
import usePermission from "../../customHook/usePermission";
import StatusModal from "../../components/StatusModal/StatusModal";
import { excelDown } from "../../assets/img/imgIndex";
import axios from "axios";

const PinCodeView = () => {
    const location = useLocation();
    const [users, setUsers] = useState([]);

    const getPersistedPage = () => {
        const storedPage = sessionStorage.getItem("pincodeSelectedPage");
        return location?.state?.page || (storedPage ? Number(storedPage) : 1);
    };
    const getPersistedDate = () => {
        return location?.state?.date || sessionStorage.getItem("pincodeSelectedDate") || "";
    };

    const [page, setPage] = useState(getPersistedPage());
    const [searchText, setSearchText] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [pagination, setPagination] = useState(null);
    const [address, setAddress] = useState('')
    const [popup, setPopup] = useState(false);
    const navigate = useNavigate();
    const permission = usePermission();

    const pageRef = useRef(page);

    const [dateValue, setDateValue] = useState(getPersistedDate());

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    useEffect(() => {
        sessionStorage.setItem("pincodeSelectedPage", String(page || 1));
    }, [page]);

    useEffect(() => {
        if (location?.state?.date) {
            setDateValue(location.state.date);
            sessionStorage.setItem("pincodeSelectedDate", location.state.date);
        }
    }, [location?.state?.date]);

    useEffect(() => {
        if (location?.state?.page) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);

    const handleView = async (row) => {
        console.log("ROW DATA:", row);

        if (row?.id) {
            navigate("/pincode-user", {
                state: { id: row?.id, page: pageRef.current },
            });
        }
    };

    const handleStatusView = async (row) => {

        if (row?.id) {
            const res = await get(`${URLS.USERADDRESS}${row?.id}/`);
            console.log("resadders", res);
            if (res?.status === 'success') {
                setAddress(res);
                setPopup(true);
            }

        }
    }

    const columns = useMemo(() => {
        let d = [
            {
                Header: "S.No",
                accessor: "sno",
                disableSortBy: true,
                width: "1%",
                Cell: ({ row }) => {
                    return (
                        <span className="sno">
                            {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
                        </span>
                    );
                },
            },
            {
                Header: "Pin Code",
                accessor: "pincode",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },
            {
                Header: "User Count",
                accessor: "user_count",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },

        ];



        let action = {
            Header: "Action",
            accessor: "action",
            disableSortBy: true,
            width: "20%",
            Cell: ({ row }) => {
                return (
                    <>
                        {permission?.includes("CAN-VIEW-USERS") && (
                            <button
                                className="action-btn"
                                onClick={() => handleView(row?.original)}
                            >
                                <FaEye />
                            </button>
                        )}
                    </>
                );
            },
        };

        return [...d, action];
    }, [page]);

    const handleClearSearch = () => {
        setSearchText("");
        setPage(1);
    };

    const fetchUsers = async () => {
        try {
            let res = await get(
                `${URLS.PINCODEVIEW}?date=${dateValue}&page=${page || 1}&search=${searchText || ""}`
            );
            console.log("Users list res:", res);
            if (res?.status === "success") {
                setUsers(res?.data || []);
                setTotalCount(res?.count || 0);
                setPagination({
                    current_page: res?.current_page || 1,
                    last_page: res?.total_pages || 1,
                });
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [page, searchText]);

    const handleDownload = async () => {
        const token = await localStorage.getItem("token");

        try {
            const response = await axios.get(
                `${BASE_URL}admin/pincode-list-by-date/?date=${dateValue}&download=excel`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Pincode_Report.xlsx");
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <>
            <PageHeader title="PinCode Management" />
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
                    Total: {totalCount || 0}
                </h2>

                <div className="newssa">
                    <div onClick={handleDownload}>
                        <img src={excelDown} style={{ width: 25, height: 25 }} />
                    </div>

                    <input
                        type="text"
                        placeholder="Search"
                        className="search-input"
                        value={searchText || ""}
                        onChange={(e) => {
                            setSearchText(e.target.value);
                            setPage(1);
                        }}
                    />
                    {searchText && (
                        <FaTimes
                            className="search-clear-icon"
                            onClick={handleClearSearch}
                        />
                    )}
                </div>
            </div>
            <CommonTable
                columns={columns}
                data={users || []}
                pagecount={pagination}
                setPageno={setPage}
                pageno={page || 1}
            />
            <StatusModal isOpen={popup} onClose={() => setPopup(false)} message={address?.address} time={address?.last_click_update} />
        </>
    );
};

export default PinCodeView;
